import Button from '@ui/Button';
import Avatar from '@ui/Avatar';
import ProgressBar from '@ui/ProgressBar';
import Typography from '@ui/Typography';
import { abbreviateNumber } from '@utils/stringHelpers';
import getSymbolFromCurrency from 'currency-symbol-map';
import { cx } from 'cva';
import React from 'react';
import useStore from '@/stores/store';
import { CampaignType } from '@/constants/postType.constants';
import useJoinNonProfitDialogStore from '../store/joinNonProfitDialogSlice';
import useHasUserSession from '@/hooks/useHasUserSession';
import useConnectModalStore from '../store/connectModalSlice';
import useNonProfitSignUpPopUpStore from '../store/nonProfitSignUpPopUpSlice';
import useCompanyConnectPopUpStore from '../store/companyConnectPopUpSlice';
import OrgType from '@/constants/orgType.constant';
import { useRouter } from 'next/navigation';
import { sortBy, take } from 'lodash-es';

function DonationProgress(props) {
  const { post, className } = props;
  const donors = post.renderProps.donations.allDonors || [];
  const totalDonors = donors.length;
  const latestDonors = take(sortBy(donors, 'createdOn'), 3);
  // const donatedAmount = post.totalDonations || post.renderProps.donations.total;
  const donatedAmount = post.renderProps.donations.total || post.totalDonations;
  const goalAmount = post.sourcePostData?.goalAmount || 0;
  const currency = post.renderProps.donations.currency;
  const symbol = getSymbolFromCurrency(currency) || '$';

  const hasUserSession = useHasUserSession();
  const router = useRouter();

  const showPostContributorDialog = useStore(
    (state) => state.postContributorDialog.showDialog,
  );

  const setShowJoinNonProfitModal = useJoinNonProfitDialogStore(
    (state) => state.setOpen,
  );
  const setShowConnectModal = useConnectModalStore((state) => state.setOpen);

  const setShowNonProfitSignUpPopUp = useNonProfitSignUpPopUpStore(
    (state) => state.setOpen,
  );
  const setShowCompanyConnectPopUp = useCompanyConnectPopUpStore(
    (state) => state.setOpen,
  );

  const handleShowAllContributors = () => {
    if (hasUserSession) {
      if (post) {
        showPostContributorDialog(post, CampaignType.FundRaise, 'contributors');
      }
    } else {
      if (
        [OrgType.Business, OrgType.ChangeMakers].includes(
          post.renderProps.company.orgType,
        )
      ) {
        // setShowConnectModal(true, post.renderProps.company);
        setShowCompanyConnectPopUp(true, post.renderProps.company);
      } else {
        // setShowJoinNonProfitModal(true, post.renderProps.nonProfit);
        // setShowJoinNonProfitModal(false, post.renderProps.nonProfit);

        // const returnPath = `/onboard/nonprofit-user?nonProfitId=${post.renderProps.nonProfit?.id}`;
        // router.replace(
        //   `/api/auth/signup?returnTo=${encodeURIComponent(returnPath)}`,
        // );
        setShowNonProfitSignUpPopUp(true, post.renderProps.nonProfit);
      }
    }
  };

  const renderDonors = () => {
    if (post.totalDonors > 0) {
      return (
        <Typography
          // variant="body1"
          // variant="caption"
          variant="hyperlink"
          // color="textSecondary"
          // className="hover:text-text-hyperlink"
          className="hover:cursor-pointer"
          onClick={handleShowAllContributors}>
          {totalDonors}{' '}
          {/* {post.totalDonors > 1 ? 'people donated' : 'person donated'} */}
          {totalDonors > 1 ? 'donations' : 'donation'}
        </Typography>
      );
    }
    return null;
  };

  // if (latestDonors.length === 0 && donatedAmount === 0) {
  //   return null;
  // }

  return (
    <div className="flex w-full flex-col items-start gap-2">
      <div className="flex w-full flex-1 flex-col items-start justify-start gap-2 lg:flex-row lg:items-center lg:gap-4">
        <div className="flex flex-1 items-center gap-4">
          <div className="flex items-center -space-x-4">
            {latestDonors.length > 0 &&
              latestDonors.map((donor, index) => (
                <div
                  key={index}
                  className={cx(
                    'relative inline',
                    `z-${(latestDonors.length - index) * 10}`,
                  )}>
                  <Avatar
                    key={donor.id}
                    profile="user"
                    src={donor.avatar}
                    alt={`${donor.firstName} ${donor.lastName}`}
                  />
                </div>
              ))}
          </div>
          <div>{renderDonors()}</div>
        </div>
        <div
          className={cx(
            'flex w-full items-center gap-4 rounded-lg bg-body-background px-4 py-1 lg:ml-auto lg:w-auto',
            className,
          )}>
          <div className="flex items-end">
            <Typography variant="h3" className="whitespace-nowrap">
              {symbol}
              {abbreviateNumber(donatedAmount)}
            </Typography>
            <Typography variant="body2" className="whitespace-nowrap">
              /{symbol}
              {abbreviateNumber(goalAmount)}
            </Typography>
          </div>
          <div className="w-36 flex-1">
            <ProgressBar
              value={donatedAmount}
              max={goalAmount}
              size="small"
              background="white"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DonationProgress;
